<div class="overlap_panel_wrapper">
  <div class="overlap_panel_sidebar">
    <div class="side_header">
      <div class="cross_wrap">
        <a href="javascript:void(0);" (click)="close()" >
          <img src="../../../../assets/img/cross_icon.svg" alt="" class="icon">
        </a>
      </div>
      <p class="company_name">Staff Information</p>
      <div class="back_wrap" >
        @if (stepper.selectedIndex > 0) {
          <a (click)="goBack(stepper)" class="back-button">
            <img src="../../../../assets/img/left_orange_arrow.svg" alt="Back" class="arrow">
            <span>Back</span>
          </a>
        }
      </div>
    </div>
    <div class="sidebar_accordion">
      <app-staff-step-preview [step]="step" [form]="staffForm" [isEdit]="isEdit"></app-staff-step-preview>
    </div>
  </div>

  <div class="overlap_right_panel">
    <form [formGroup]="staffForm"  novalidate>
      <mat-horizontal-stepper #stepper  [linear]="true" (selectionChange)="onStepChanged($event, stepper)">
        <mat-step formGroupName="step01" [stepControl]="staffForm.get('step01')!">
          <ng-template matStepLabel>Staff Information</ng-template>
          <app-staff-info-form  formControlName="staffInformation" [isEdit]="isEdit"  [form]="staffForm.get('step01')" [model]="editData"></app-staff-info-form>
          <div class="controls">
            <button type="button" mat-button class="btn_transparent" (click)="close()">Cancel</button>
            <button  mat-button matStepperNext (click)="touchFormControls('step01')" class="btn_solid_color py-2">Next  <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>
        <mat-step formGroupName="step02" [stepControl]="staffForm.get('step02')!">
          <ng-template matStepLabel>Staff Detail</ng-template>
          <app-staff-detail formControlName="staffDetail" [isEdit]="isEdit" [form]="staffForm.get('step02')" [model]="editData"></app-staff-detail>
          <div class="controls">
            <button type="button" matStepperPrevious mat-button class="btn_transparent">Back</button>
            <button  mat-button matStepperNext (click)="touchFormControls('step02')" class="btn_solid_color py-2">Next  <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>

        <mat-step formGroupName="step03" [stepControl]="staffForm.get('step03')!">
          <ng-template matStepLabel>Address</ng-template>
          <app-staff-address-form  formControlName="staffAddress" [isEdit]="isEdit" [form]="staffForm.get('step03')" [model]="editData"></app-staff-address-form>
          <div class="controls">
            <button type="button" matStepperPrevious  mat-button class="btn_transparent" >Back</button>
            <button  mat-button matStepperNext (click)="touchFormControls('step03')" class="btn_solid_color py-2">Next  <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>

        <mat-step formGroupName="step04" [stepControl]="staffForm.get('step04')!">
          <ng-template matStepLabel>Salary</ng-template>
          <app-staff-salary formControlName="salary" [isEdit]="isEdit" [form]="staffForm.get('step04')" [model]="editData"></app-staff-salary>
          <div class="controls">
            <button type="button" matStepperPrevious mat-button class="btn_transparent">Back</button>
            <button  mat-button matStepperNext (click)="touchFormControls('step04')" class="btn_solid_color py-2">Next  <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>

        <!-- Certification step - only show in create mode -->
        @if (!isEdit) {
          <mat-step formGroupName="step05" [stepControl]="staffForm.get('step05')!">
            <ng-template matStepLabel>Certifications</ng-template>
            <app-staff-certification formControlName="certifications" [isEdit]="isEdit" [form]="staffForm.get('step05')" [model]="editData"></app-staff-certification>
            <div class="controls">
              <button type="button" matStepperPrevious mat-button class="btn_transparent" >Back</button>
              <button  mat-button matStepperNext (click)="touchFormControls('step05')" class="btn_solid_color py-2">Next  <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
            </div>
          </mat-step>
        }

        <mat-step>
          <ng-template matStepLabel>Preview</ng-template>
          <app-staff-final-preview [step]="step" [form]="staffForm" [isEdit]="isEdit"></app-staff-final-preview>
          <div class="controls">
            <button type="button" matStepperPrevious mat-button class="btn_transparent">Back</button>
            <button
              mat-button
              (click)="onSubmit()"
              class="btn_solid_color py-2"
              [disabled]="isSaving">
              @if (isSaving) {
                <mat-progress-spinner
                  diameter="16"
                  strokeWidth="3"
                  mode="indeterminate"
                  color="accent"
                  class="btn-spinner mr-3">
                </mat-progress-spinner>
              }
              <span class="btn-label">{{isEdit ? 'Update':'Create'}}</span>
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </form>
  </div>
</div>

